export const visit = (vm, at) => {
vm(require("share-transcript-modal/lang/en.lyaml"));
vm(require("recording-review-components-lib/lang/en.lyaml"));
at({ "en": { "transcriptSidebar": { "title": "Recording Review", "errorMessage": "Something went wrong while loading this recording. Please refresh or try again later." } } });
};